import { createRoot } from "react-dom/client";

import "@fontsource-variable/inter";
import "@fontsource-variable/jetbrains-mono";

import "@fontsource/sora/400.css";
import "@fontsource/sora/600.css";
import "@fontsource/sora/700.css";
import App from "./App.tsx";
import "./index.css";
import { GlobalLoadingProvider } from "@/components/providers/GlobalLoadingProvider";

createRoot(document.getElementById("root")!).render(
  <GlobalLoadingProvider>
    <App />
  </GlobalLoadingProvider>,
);
